import { useDataValue } from 'Simple/Data.js'
import { FREQUENTLY_USED_VALUE_KEYS } from 'Data/constants.js'
import { useMemo } from 'react'

import { getFrequentlyUsedSelectionValues } from 'Logic/localStorage.js'

export default function useDataTransform(props, data) {
  let task_assignee = useDataValue({
    context: 'card',
    path: 'assignee',
    viewPath: props.viewPath,
  })

  let current_user = useDataValue({
    context: 'global',
    path: 'user',
    viewPath: props.viewPath,
  })

  let xid = useDataValue({
    context: 'global',
    path: 'current_location.xid',
    viewPath: props.viewPath,
  })

  let frequently_used = getFrequentlyUsedSelectionValues({
    key: FREQUENTLY_USED_VALUE_KEYS.TASK_ASSIGNEES,
    xid,
  })

  return useMemo(() => {
    if (!data) return data

    return [
      // if there isn't already an assignee remove the 'No assignee' aka delete option
      ...(task_assignee?.id ? data : data.filter(item => item.id !== 'delete')),
      // current user
      ...[
        {
          id: current_user.id,
          text: `${current_user.first_name} ${current_user.last_name} (me)`,
        },
      ],
      // last 5 used
      ...frequently_used,
    ]
  }, [data, task_assignee, frequently_used]) // eslint-disable-line
}
